import React from 'react';

const disabledTextColor = "var(--text-soft-color)";
const textColor = "var(--text-color)";
const mutedTextColor = "var(--text-muted-color)";

const ToggleInput = ({
  label,
  callback = () => {},
  value,
  disabled,
  inputContainerStyle = {},
  toggleLabelOff,
  toggleLabelOn,
  id,
  description
}) => (
  <div
    className="input-container"
    style={{
      marginBottom: "20px",
      ...inputContainerStyle,
    }}
  >
    {label &&
      <div
        className="input-label"
        style={{
          color: disabled ? disabledTextColor : textColor,
          paddingBottom: '5px'
        }}
      >
        {label}
      </div>
    }
    {description &&
      <div
        className="input-label"
        style={{
          fontStyle: "italic",
          margin: "5px 0px",
          marginBottom: "10px",
          paddingTop: "0px",
          marginTop: "-10px",
          color: mutedTextColor,
        }}
      >
        {description}
      </div>
    }
    <span style={{ display: 'flex', alignItems: 'center' }}>
      <span
        style={{
          marginRight: "0px",
          color: value ? mutedTextColor : textColor
        }}
      >
        {toggleLabelOff}
      </span>
      <input
        className="tgl tgl-light"
        id={`cb_${label || id}`} // NEEDS TO BE UNIQUE
        type="checkbox"
        checked={!!value}
        onChange={() => {
          callback(!value)
        }}
        disabled={disabled}
      />
      <label
        className="tgl-btn "
        htmlFor={`cb_${label || id}`}
      />
      <span
        style={{
          marginLeft: "-5px",
          color: value ? textColor : mutedTextColor
        }}
      >
        {toggleLabelOn}
      </span>

    </span>
  </div>
);

export default ToggleInput;
